export default __webpack_public_path__ + "static/mobile-header-logo-7cb3b8e3344e780f2427568771b13e01.svg";